import { Category } from '@/@types/category';
import { Table } from '@/components/common';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';

export interface ICategoriesTableProps {
  data: Category[];
  columns: ColumnDefinitionType<Category>[];
  sort?: 'desc' | 'asc';
  sortBy?: keyof Category;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function CategoriesTable({
  data,
  columns,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: ICategoriesTableProps) {
  return (
    <Table
      data={data}
      columns={columns}
      additionalData={actions}
      sort={sort}
      sortBy={sortBy}
      onSort={onSort}
      pagination={pagination}
    />
  );
}
